var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M0 0v100h100v-100h-100zM93.75 93.75h-87.5v-87.5h87.5v87.5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }